type ProgramRowLayoutParams = {
  compactRowHeight: number;
  liveRowHeight: number;
  /** Index of the taller live/prime-time card, or null when every row is compact. */
  liveIndex: number | null;
};

/**
 * FlatList `getItemLayout` for a channel column where a single row (the live /
 * prime-time card) is taller than the uniform compact rows. Stays O(1) per row:
 * only rows after the live index carry the extra height in their offset.
 */
const getProgramRowLayout =
  ({ compactRowHeight, liveRowHeight, liveIndex }: ProgramRowLayoutParams) =>
  (_: unknown, index: number) => {
    const isLiveRow = liveIndex != null && index === liveIndex;
    const length = isLiveRow ? liveRowHeight : compactRowHeight;

    const extra = liveRowHeight - compactRowHeight;
    const offset =
      index * compactRowHeight +
      (liveIndex != null && index > liveIndex ? extra : 0);

    return { length, offset, index };
  };

export default getProgramRowLayout;
